import { Carousel } from "antd";
import styled from "styled-components";

export const StyledCameraPreviewOverlay = styled.div`
    position: absolute;
    z-index: 1;
    top: 70px;
    left: 16px;
`;

export const StyledProductItem = styled.div`
    display: flex !important;
    flex-direction: column;
    gap: 16px;
    height: 50vh;
    min-height: 300px;
    max-height: 400px;
`;

export const StyledImageWrapper = styled.div`
    flex: 1;
    overflow: hidden;

    .ant-image {
        width: 100%;
        height: 100%;
    }

    .ant-image-img {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }
`;

export const StyledCarousel = styled(Carousel)`
    .slick-arrow {
        color: ${({ theme }) => theme.primaryTypographyColor};
    }
`;
